"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateMyChartOpenSchedulingConfiguration = void 0;
function validateMyChartOpenSchedulingConfiguration(config, issues) {
    if (!issues) {
        issues = [];
    }
    if (!config) {
        issues.push({
            name: 'config.third_party.mychart_open_scheduling',
            message: '"mychart_open_scheduling" configuration is missing.'
        });
        return false;
    }
    if (!config.url) {
        issues.push({
            name: 'config.third_party.mychart_open_scheduling.url',
            message: '"url" is required.'
        });
        return false;
    }
    return true;
}
exports.validateMyChartOpenSchedulingConfiguration = validateMyChartOpenSchedulingConfiguration;
//# sourceMappingURL=validation.js.map